package org.hs_soft.runmynesto.domain.model.home.options.export.option_credit_card

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class Data(
    @SerialName("cashAssist")
    val cashAssist: CashAssist?
)